import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const defaultStyle = {};

function ButtonGroup({
  className = null,
  style = defaultStyle,
  block = false,
  stick = 'none',
  children,
  ...otherProps
}) {
  const hasStick = stick !== 'none';

  const buttonGroupClass = classNames(className, 'button-group', {
    'button-group--block': block,
    [`button-group--stick-${stick}`]: hasStick,
  });

  return (
    <div className={buttonGroupClass} style={style} {...otherProps}>
      {children}
    </div>
  );
}

ButtonGroup.propTypes = {
  block: PropTypes.bool,
  stick: PropTypes.oneOf(['none', 'top', 'bottom']),
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  style: PropTypes.shape(),
};

export default ButtonGroup;
